<div class="bcg">
  <div class="mb-2">
    <div class="page_responsive card ">
      <div class="card-body">
        <div class="container">
          <div class="d-flex justify-content-between mb-3">
            <div>
              <span class="title_header">Review Order</span>
            </div>
            <div>
            </div>
          </div>

          <p-accordion [multiple]="true" [value]="['0','1','2','3']">
            <p-accordion-panel value="0">
              <p-accordion-header>Order Details</p-accordion-header>
              <p-accordion-content>
              <div class="data-card">
                <div class="row">
                  <div class="col">
                    <div class="ms-2 r1">Service Type: <span class="r1s">{{serviceType}}</span></div>
                  </div>
                  <div class="col">

                  </div>
                  <div class="col">
                    <div class="r1"><span class="r1s"></span></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="r1 ms-2">Order date:<span class="r1s">{{currentDate | date: "MMMM d, yyyy, h.mm a"
                        }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class=" r1">Order placed by: <span class="r1s">{{userName}}</span></div>
                  </div>
                  <div class="col">
                    <div class=" r1">Reference Number: <span class="r1s">{{orderDetails?.referance_id}}</span></div>
                  </div>

                </div>
              </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="1" *ngIf="!!paymentDetails" class="m-1">
              <p-accordion-header>Payment Details</p-accordion-header>
              <p-accordion-content>
                  <div class="data-card m-1">
                    <div class="row ">
                      <!-- <div class="row row-cols-2 row-cols-lg-5 g-3 g-lg-4"> -->
                      <div class="col">
                        <div class="r1 spacing">Payee Name: <span class="r1s">{{paymentDetails.payeeName}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class=" r1 spacing">Payee Email: <span
                            class="r1s">{{paymentDetails.payeeEmail}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class=" r1 spacing">Payee Contact: <span
                            class="r1s">{{paymentDetails.payeeMobileNumber}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class=" r1 spacing">Amount: <span class="r1s">{{paymentAmount}}</span></div>
                      </div>

                    </div>
                  </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="2" *ngIf="stampDetails.length != 0" class="m-1">
              <p-accordion-header>E-Stamp Details</p-accordion-header>
              <p-accordion-content>
                <div *ngFor="let estamp of stampDetails;">
                  <div class="data-card m-1">
                    <div class="row ">
                      <!-- <div class="row row-cols-2 row-cols-lg-5 g-3 g-lg-4"> -->
                      <div class="col">
                        <div class="r1 spacing">First Party Name: <span class="r1s">{{estamp.first_party_name}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class=" r1 spacing">Second Party Name: <span
                            class="r1s">{{estamp.second_party_name}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class=" r1 spacing">Stamp duty amount: <span
                            class="r1s">{{estamp.stamp_duty_amount}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class=" r1 spacing">Execution date: <span class="r1s">{{estamp.execution_date | date: "MMMM
                            d,
                            yyyy"}}</span></div>
                      </div>

                    </div>
                    <div class="row ">
                      <div class="col">
                        <div class="r1 spacing">Stamp duty paid by: <span
                            class="r1s">{{estamp.stamp_duty_paid_by_name}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class="r1 spacing">Consideration Amount: <span
                            class="r1s">{{estamp.consideration_amount}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class=" r1 spacing">Description: <span class="r1s">{{estamp.description}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class=" r1 spacing">Article Name: <span class="r1s">{{estamp.article_code}}</span></div>
                      </div>
                    </div>
                    <div class="row ">
                      <div class="col">
                        <div class="r1 spacing">State: <span class="r1s">{{branchDetails?.state?.state_name}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class="r1 spacing">Branch: <span class="r1s">{{branchDetails?.name}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class="r1 spacing">Account Name: <span class="r1s">{{branchDetails?.account_name}}</span>
                        </div>
                      </div>
                      <div class="col">
                        <div class="r1 spacing">
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="3" *ngIf="signDetails.length !=0" class="m-1">
              <p-accordion-header>E-Sign Details</p-accordion-header>
              <p-accordion-content>
                <div *ngFor="let esign of signDetails;">
                  <div class="data-card m-1">

                    <div class="row mt-2">
                      <div class="col">
                        <div class=" r1 spacing"><span class="px-1"> Party Name:</span> <span class="r1s">{{esign.name}}
                          </span> </div>
                      </div>
                      <div class="col">
                        <div class="r1 spacing">Party Email: <span class="r1s">{{esign.email}}</span></div>
                      </div>
                      <div class="col">
                        <div class="r1 spacing">Party Mobile: <span
                            *ngIf="esign.contact_number !== ''; else showContactNA"
                            class="r1s">{{esign.contact_number}}</span>
                          <ng-template #showContactNA>
                            <span class="r1s">NA</span>
                          </ng-template>
                        </div>
                      </div>
                      <div class="col">
                        <div class="r1 spacing">Signature type: <span class="r1s">{{esign.method}}</span></div>
                      </div>

                    </div>
                    <div class="row mt-2">
                      <div class="col">
                        <div class="r1 spacing">Pages: <span class="r1s">{{esign.pages}}</span></div>
                      </div>
                      <div class="col">
                        <div class="r1 spacing">Sign Position: <span class="r1s">{{esign.sign_position}}</span></div>
                      </div>
                      <div class="col">
                        <div class="r1 spacing">Send Document: <span class="r1s">{{ esign.send_document ? 'Yes' : 'No'
                            }}</span></div>

                      </div>
                      <div class="col">
                        <div class="r1 spacing">Send Notification: <span class="r1s">{{esign.send_notification ? 'Yes' :
                            'No'}}</span></div>
                      </div>
                    </div>

                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>

          </p-accordion>
          <form [formGroup]="reviewDetails">
            <div class="card-body" style="padding:0">
              <div class="form_outline_sty">
                <div class="form_inputFields col-lg-4 col-sm-4 col-md-4">
                  <span class="form_field">Checker</span><span class="color_red">*</span>
                  <div class="overlay">
                    <app-multiselect-dropdown class="custom-dropdown_1 text-left max_height" placeholder="Select Checker"
                      [options]="userData" formControlName="reviewer" optionLabel="first_name"
                      (onChange)="selectReviewer()"></app-multiselect-dropdown>

                  </div>
                  <span class="p-error" style="font-size: 0.5rem;"
                    *ngIf="submitted && reviewDetails.get('reviewer')?.hasError('required')">*Select Reviewer
                  </span>

                </div>
              </div>

              <div formArrayName="reviewEmail">

                <div class="form_outline_sty ">
                  <div class="row">

                    <section class="col-lg-4 col-sm-12 col-md-6"
                      *ngFor="let details of reviewEmailArray().controls; let detailsIndex=index"
                      [formGroupName]="detailsIndex">
                      <strong class="m-1 mt-2 title_header_0">Reviewer {{detailsIndex +1}}</strong>
                      <div class="form_inputFields">
                        <div style="display:flex">
                          <input class="form-control " formControlName="email" placeholder="Enter Email" maxlength="50"
                            readonly="true" pInputText type="text">
                          <span class="p-error" style="font-size: 0.5rem;"
                            *ngIf="submitted && reviewEmailArray().at(detailsIndex).get('email')?.hasError('required')">*Enter
                            Email</span>
                          <div class="col-lg-1 col-sm-1 col-md-1 remove_btn ps-2">
                            <button pButton pRipple type="button" icon="pi pi-trash"
                              (click)="removeDetails(detailsIndex)" class="p-button-sm"></button>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>

              </div>
            </div>


          </form>
          <div class="flex_row mt-4 text-right">
            <div>
              <p-button label="Back" (click)="goBack()" styleClass="p-button-sm"></p-button>
            </div>
            <div class="ms-2">
              <p-button label="Place Order" (click)="placeOrder()" styleClass="p-button-sm-outline">
              </p-button>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>